<!-- 登录页 -->
<template>
  <div class="webcardbindMain">

    <div class="webwrapCardBody" style="max-height:400px; overflow-y:auto; " v-if="trueCode == 1">
      <div class="Hseat"></div>
      <div class="inputForm">
        <div class="telDivCard">
          <i class="iconfont iconiconfontshouji"></i>
          <!-- pswWidth1 -->
          <input class="pswWidth1" type="text" placeholder="请输入卡号" v-model="cardNumber" />
           <i class="iconfont iconscan" style="float: right" @click="scancode"></i>
        </div>
        <div class="telDivCard tel_passworld">
          <i class="iconfont iconsuo"></i>
          <input :type="eysTrue ? 'password' : 'text' " placeholder="电子码或密码8-12位不区分大小写" v-model="cardPwd" class="pswWidth1">
          <i :class="['iconfont', eysTrue ? 'icon-eyeopen' : 'icon-eyeclose']" style="float: right" @click="() => eysTrue = !eysTrue"></i>
        </div>
        <div class="clearBoth"></div>
        <!-- v-if="codeNum >= 3" -->
        <div class="telDivCard">
          <i class="iconfont iconiconfont5"></i>
          <input class="pswWidth" type="text" placeholder="请输入验证码" v-model="imageCode" />
          <img :src="imgUrl" @click="getCode" />
        </div>
        <div class="Hseat"></div>
      </div>
      <div class="loginBtnCard" @click="login">确定</div>
      <div class="agremmentCard">
        <p>温馨提示：如果只有密码，无需填写第一个输入框内容</p>
      </div>
    </div>
     
      <div class="center_box_list" v-if="trueCode == 0 ">页面加载中...</div>
      <div v-show="isOpen" class="popBg">
        <div class="popUp">
          <div class="tishi">您的看购卡已成功兑换嘉年华门票，<br/> 快去电影嘉年华小程序查看权益吧！</div>
          <div class="gojnh">
            <wx-open-launch-weapp id="launch-btn" username="gh_70702582557c" path="/pages/sn-tabbar/sn-tabbar?curPage=2&card_bag=1">
              <script type="text/wxtag-template">
                <style>
                  .btn { 
                    width:100%;
                    height:100%;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                  }
                </style>
                <div class="btn">前往电影嘉年华小程序</div>
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
      
  </div>
</template>

<script>
import * as api from '@/api'
import JmmToast from '@/components/JmmToast'
import wx from 'weixin-js-sdk'
import '@/assets/stylecss/iconfont.css'
var Base64 = require('js-base64').Base64
export default {
  name: 'login',
  data() {
    return {
      trueCode: '0',

      eysTrue: true,     // 密码框 显示小眼睛
      token: 'jjcimpilpgejfeehkdinjlbgabbgchhe',
      sign: '',
      cardNumber: '',
      cardPwd: '',
      code: '',
      scanlinks: '',
      businessid: '',
      imgUrl: '',
      imageCode: '',
      appid: "wxc528cd4698883637",
      cardcode: '',
      cardrights: '',    
      isOpen:false,        //是否显示跳转小程序弹窗  
      codeNum:0,           //如果大于等于3显示验证码否则不显示
      channel: '',         // 识别是不是百货的业务     
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.cardNumber = this.$route.query.cardNumber;
    this.cardPwd = this.$route.query.cardPwd;
    this.code = this.$route.query.code;
    this.channel = this.$route.query.channel;
    //判断渠道ID
    if(null == this.channel || undefined == this.channel){
      this.channel = '';
    }
    this.fetch(this.code);
    this.getxcx();
  },
  mounted () {
    
  },
  components: { JmmToast },
  methods: {
    async getxcx(){
      let that = this
         const url = encodeURIComponent(location.href.split("#")[0]); //获取当前页面路由
        //  let url = location.href.split('#')[0]
         const res = await api.user.getSign(url)
          // console.log(res, ' === getSign返回')
        if (res.code == '000000') {
          wx.config({
            debug: false, 
            appId: 'wxc528cd4698883637', // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-weapp']
          })

            
        }     
    },
     //  code 登录
  async fetch(codeNum) {
    console.log('我是fetch登录')
    try {
      let info = { "appId": this.appid, "wxcode": codeNum}
    
        localStorage.setItem('reToken', this.token)
        const res = await api.user.getwebLogin(info)
        if (res.code == "000000") { 
            this.sign = res.data.sign
            localStorage.setItem('reSESSIONKEY', res.data.SESSIONKEY)
            localStorage.setItem('codeSign', res.data.sign)
            this.getCode();
        } 
    } catch (err) {
      console.log(err)
    }
  },

    // 图形验证码
    async getCode() {
      try {
        localStorage.setItem('reToken', this.token)
        let data = await api.user.getCode(this.sign, 'img')
        this.imgUrl = window.URL.createObjectURL(data)
        
        this.imgUrl ? this.trueCode = 1 : ''

      } catch (err) {
        console.log(err)
      }
    },
    // 点击登录
    async login() {
      let _this = this
      try {

        if (!_this.cardPwd) {
          JmmToast('请输入正确的密码')
          return
        }
        // if(this.codeNum >= 3){
          if (!_this.imageCode) {
            JmmToast('请输入完整的验证码')
            return
          }
        // }
      
        // 执行登陆接口
        let params = {
          sign: _this.sign,
          card: _this.cardNumber,
          pwd: _this.cardPwd,
          isbind: 1,
          scanLinks: '',
          businessid: '10002',
          imageCode: _this.imageCode,
          channel: 'PLUS',
          // imageCode: this.codeNum <= 3 ? 0 : _this.imageCode,
        }
        localStorage.setItem('reToken', this.token)
        const res = await api.user.webCardBindPLUS(params)
        if (res.code == '000000') {
          _this.isOpen = true;
          JmmToast(res.message)

        } else {
          // this.codeNum ++;
          // if(this.codeNum >= 3){
          //   this.getCode();
          // }
          JmmToast(res.message)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 点击扫码 按钮 打开相机
   async getSigncode() {
      try {
         let that = this
         const url = encodeURIComponent(location.href.split("#")[0]); //获取当前页面路由
        //  let url = location.href.split('#')[0]
         const res = await api.user.getSign(url)
          // console.log(res, ' === getSign返回')
        if (res.code == '000000') {
          wx.config({
            debug: false, 
            appId: 'wxc528cd4698883637', // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          })

            wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
              success: function(res) {
                that.Toscan(res.resultStr)
              },
              fail: function(res) {
                console.log(res)
              }
          });
        }                                                                                                                        
      } catch (error) {
        console.log(error)
        // JmmToast(error)
      }
    },
    
    // 点击二维码获取
    scancode() {
      this.getSigncode()
    },
    // 扫码接口调用
   async Toscan (can) {
      let info = {
          businessid: '10002',
          sign: this.sign,
          scanLinks: Base64.encode(can),
          isbind: 1,
          card: '',
          pwd: '',
          channel: 'PLUS'
      }
      localStorage.setItem('reToken', this.token)
      const res = await api.user.cardBindScanLinks(info)
      
      if (res.code == '000000') {
        
        // window.location.href = this.channel ? toUrl1 : toUrl2
         
      } else {
        JmmToast(res.message)
      }
      
   }
   
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'
.tel_passworld img{
  width: 15px; 
  vertical-align: middle;
  float: right;
}

.webcardbindMain
  width 100%
  height 100%
  overflow hidden
  background #fff
.webcardbindMain .webcardloginHead
  width 100%
  height 50px
  line-height 50px
  text-align center
.webcardbindMain .webcardloginHead .headleft
  float left
  text-align left
  width 70%
  font-size 30px
  height 50px
.webcardbindMain .webcardloginHead .headright
  float right
  text-align right
  width 30%
  font-size 30px
  height 50px
.webwrapCardBody
  width 100%
  height 100%
.webwrapCardBody .Hseat
  height 60px
.webwrapCardBody .telDivCard
  width calc(100% - 150px)
  margin 15px auto
  height 110px
  border-bottom 1px solid #ddd
  i
    font-style normal
    margin-top 30px
    float left
    vertical-align middle
  input
    height 80px
    font-size 45px
    margin-left 20px
    border none
    vertical-align middle
  button
    border 2px solid $codeColor
    width 180px
    height 66px
    font-size 28px
    background $codeColor
    color black
    float right
  img
    width 30% !important
    height 45px !important
    display inline-block
    vertical-align middle
  .pswWidth
    font-size 32px;
    width 50% !important
    display inline
  .pswWidth1
    font-size 32px;
    width 80% !important
    display inline
.loginBtnCard
  width calc(100% - 150px)
  height 90px
  line-height 90px
  margin 0 auto
  background $background
  border-radius 45px
  font-size 34px
  text-align center
  color $color
.agremmentCard
  width calc(100% - 224px)
  margin 32px auto
  font-size 24px
.clearBoth
  clear both
.leftRouter
  float $floLeft
.rightRouter
  float $florRight
.card
  background #fff
  height 100%
input::-webkit-input-placeholder /* WebKit browsers */
  font-size 28px
  line-height normal
input::-moz-input-placeholder /* Mozilla Firefox */
  font-size 28px
  line-height normal
input::-ms-input-placeholder /* Internet Explorer */
  font-size 28px
  line-height normal

  .codeLogin_sao {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.3;
  }


.center_box_list {
  font-size: 28px;
  font-family: Source Han Sans SC VF;
  text-align: center;
	border-radius: 20px;
	width: 80%;
	height: 350px;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

.popBg{
  background: rgba(0,0,0,.8);
  position: fixed;
  top: 0;
  width 100%;
  height 100%;
  z-index 99;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .popUp{
    width 631px;
    height 627px;
    background: url('https://kungfu-park-img.oss-cn-zhangjiakou.aliyuncs.com/park_img/revision/tup.png') no-repeat;
    background-size: 100% 100%;
    overflow hidden;
    .tishi{
      width 100%;
      text-align: center;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin: 265px 0 83px; 
    }
    .gojnh{
      width: 385px;
      height: 80px;
      background: #FC4E4D;
      border-radius: 50px;
      margin: 0 auto;
      overflow hidden;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/zxwxcardbind/index.vue